import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { BoardMemberFormTypes } from "models/formTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { BoardMemberDetailsToDoFormContainerProps } from "models/propTypes/boardMemberPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import BoardMemberDetailsToDoForm from "./boardMemberDetailsToDoForm";
//#endregion
import * as Yup from "yup";
import { RegularExpressions } from "utils/helpers";

const BoardMemberDetailsToDoFormContainer: ForwardRefRenderFunction<
  FormHandles,
  BoardMemberDetailsToDoFormContainerProps
> = (props, ref) => {
  const { boardMembers } = props;

  const initialValues: BoardMemberFormTypes.BoardMembersDisplay = {
    boardMembers: boardMembers ?? [],
  };

  const validationSchema = Yup.object<BoardMemberFormTypes.BoardMembersDisplay>({
    boardMembers: Yup.array()
      .min(1)
      .of(
        Yup.object<BoardMemberFormTypes.BoardMemberDisplay>({
          boardMember: Yup.object<BoardMemberFormTypes.BoardMemberWithRoles>({
            name: Yup.string(),
            mail: Yup.string().email(TranslationKeys.Validations.InvalidEmail),
            phoneNumber: Yup.string().matches(RegularExpressions.PhoneNumber, {
              message: TranslationKeys.Validations.InvalidPhoneNumber,
              excludeEmptyString: false,
            }),
            socialSecurityNumber: Yup.string(),
            roles: Yup.array().of(
              Yup.object<BoardMemberFormTypes.Role>({
                roleName: Yup.string(),
                appointmentDate: Yup.date(),
              })
            ),
          }),
          socialSecurityNumber: Yup.string(),
          mail: Yup.string().email(TranslationKeys.Validations.InvalidEmail),
        })
      ),
  });

  return (
    <BoardMemberDetailsToDoForm
      ref={ref}
      {...props}
      defaultValues={initialValues}
      validationSchema={validationSchema}
    />
  );
};

export default forwardRef(BoardMemberDetailsToDoFormContainer);
